import CalendarDate from '@/components/common/Date/Instance/CalendarDate'
import momentHijri from 'moment-hijri'
import { MAX_UMMALQURA_YEAR, MIN_UMMALQURA_YEAR, UMMALQURA_DATA } from '@/components/common/Date/Utils/helpers'

export default class HijriCalendarDate extends CalendarDate {
    static getCalendarYearBounds () {
        return [1300, 1500]
    }

    /**
     * @return {Date}
     */
    static now () {
        return new Date(momentHijri().format('iYYYY-iMM-iDD'))
    }

    /**
     * @param {number|null} year
     * @param {number|null} month
     * @param {number|null} day
     * @returns {HijriCalendarDate}
     */
    newInstance (year = null, month = null, day = null) {
        return new HijriCalendarDate(year ?? this.year, month ?? this.month, day ?? this.day)
    }

    /**
     * @returns {HijriCalendarDate}
     */
    endOfMonth () {
        return this.setDay(this.daysInMonth())
    }

    /**
     * @returns {number}
     */
    daysInMonth () {
        let days = this.moment.iDaysInMonth(this.year, this.month)
        if (isNaN(days)) {
            days = this.daysInMonth2()
        }
        return days
    }

    daysInMonth2 () {
        let year = this.year
        const month = this.month

        function month2off (month, year) {
            const ii = year - MIN_UMMALQURA_YEAR.hijri
            return month - 1 + 12 * ii
        }

        let t
        if (year > MIN_UMMALQURA_YEAR && year < MAX_UMMALQURA_YEAR.hijri) {
            const i = month2off(month, year)
            t = UMMALQURA_DATA[i + 1] - UMMALQURA_DATA[i]
        } else if (month === 12) {
            if (year < 0) {
                year = year + 5521
            }
            if (Math.round((year % 30) * 0.36667) > Math.round(((year - 1) % 30) * 0.36667)) {
                t = 30
            } else {
                t = 29
            }
        } else {
            t = 29 + (month % 2)
        }
        return t
    }

    /**
     * @return number
     */
    getWeekDay () {
        return this.moment.day()
    }

    // private
    get moment () {
        return momentHijri(`${this.year}-${this.month + 1}-${this.day}`, 'iYYYY-iMM-iDD')
    }
}
